import type { CustomUiText } from './customUiTexts.shared';

export const GLOBAL_ACTION_TEXT = {
  accountNotRegistered: { zh: '账号未注册，请先注册', en: 'Account is not registered, please sign up first', pt: 'A conta não está registrada, registre-se primeiro' },
  accountRegistered: { zh: '账号已注册', en: 'Account is already registered', pt: 'A conta já está registrada' },
  networkUnavailable: { zh: '当前网络不可用，请更换网络后重试', en: 'Current network is unavailable, please switch network and try again', pt: 'A rede atual não está disponível, troque de rede e tente novamente' },
  registerLimitReached: { zh: '注册次数已达上限，请稍后再试', en: 'Registration limit reached, please try again later', pt: 'O limite de registros foi atingido, tente novamente mais tarde' },
  invalidName: { zh: '名字无效', en: 'Invalid name', pt: 'Nome inválido' },
  captchaExpired: { zh: '验证码过期', en: 'Captcha expired', pt: 'O captcha expirou' },
  captchaMismatch: { zh: '验证码不匹配', en: 'Captcha does not match', pt: 'O captcha não corresponde' },
  accountRequired: { zh: '账号不能为空', en: 'Account is required', pt: 'A conta é obrigatória' },
  passwordRequired: { zh: '密码不能为空', en: 'Password is required', pt: 'A senha é obrigatória' },
  passwordRuleInvalid: { zh: '密码不符合规则', en: 'Password does not meet requirements', pt: 'A senha não atende aos requisitos' },
  accountRestricted: { zh: '账号受限', en: 'Account is restricted', pt: 'A conta está restrita' },
  passwordMismatch: { zh: '密码不匹配', en: 'Password mismatch', pt: 'As senhas não coincidem' },
  invalidAccountOrPassword: { zh: '账号或者密码错误', en: 'Account or password is incorrect', pt: 'Conta ou senha incorreta' },
  operationTooFrequent: { zh: '操作频繁，请稍后再试', en: 'Too many operations, please try again later', pt: 'Muitas operações, tente novamente mais tarde' },
  networkErrorRetry: { zh: '网络异常，请稍后再试', en: 'Network error, please try again later', pt: 'Erro de rede, tente novamente mais tarde' },
  ipNotFoundError: { zh: 'IP地址未找到，请检查网络连接或联系管理员', en: 'IP address not found, please check network connection or contact administrator', pt: 'Endereço IP não encontrado, verifique a conexão de rede ou contate o administrador' },
  systemBusyRetry: { zh: '系统繁忙，请稍后再试', en: 'System busy, please try again later', pt: 'Sistema ocupado, tente novamente mais tarde' },
  accountTakenHint: { zh: '账号已经被注册', en: 'Account has already been registered', pt: 'A conta já foi registrada' },
  captchaInvalid: { zh: '验证码错误', en: 'Captcha is invalid', pt: 'Captcha inválido' },
  inviteCodeInvalid: { zh: '邀请码无效', en: 'Invite code is invalid', pt: 'Código de convite inválido' },
  saveProfileFailed: { zh: '保存资料失败，请重试', en: 'Failed to save profile, please try again', pt: 'Falha ao salvar o perfil, tente novamente' },
  hideParticipantsFailed: { zh: '隐藏群成员设置失败', en: 'Failed to update hide members setting', pt: 'Falha ao atualizar a configuração de ocultar membros' },
  avatarUploadFailed: { zh: '头像上传失败，请重试', en: 'Avatar upload failed, please try again', pt: 'Falha no envio do avatar, tente novamente' },
  userNotFound: { zh: '用户不存在', en: 'User not found', pt: 'Usuário não encontrado' },
  groupMemberProfileBlocked: { zh: '当前群组不允许查看成员资料', en: 'Viewing member profiles is not allowed in this group', pt: 'Não é permitido ver perfis de membros neste grupo' },
  hint: { zh: '提示', en: 'Notice', pt: 'Aviso' },
  micPermissionDenied: {
    zh: '无法录音：麦克风权限被拒绝，请在浏览器设置中允许后重试',
    en: 'Cannot record: microphone access was denied. Allow it in your browser settings and try again',
    pt: 'Não é possível gravar: o acesso ao microfone foi negado. Permita-o nas configurações do navegador e tente novamente',
  },
  micPermissionDeniedShell: {
    zh: '无法录音：麦克风权限被拒绝，请在系统设置中允许后重试',
    en: 'Cannot record: microphone access was denied. Allow it in system settings and try again',
    pt: 'Não é possível gravar: o acesso ao microfone foi negado. Permita-o nas configurações do sistema e tente novamente',
  },
  voiceRecordingLost: {
    zh: '录音失败,未能发送',
    en: 'Recording failed and was not sent',
    pt: 'A gravação falhou e não foi enviada',
  },
  imageCropFailed: {
    zh: '图片处理失败,请换一张图片重试',
    en: 'Could not process this image, please try another one',
    pt: 'Não foi possível processar esta imagem, tente outra',
  },
  micUnavailable: {
    zh: '无法录音，请检查麦克风是否可用',
    en: 'Cannot record, please check that a microphone is available',
    pt: 'Não é possível gravar, verifique se há um microfone disponível',
  },
  downloadFailed: {
    zh: '下载失败，请稍后重试',
    en: 'Download failed, please try again later',
    pt: 'Falha no download, tente novamente mais tarde',
  },
  sendDeniedBanned: {
    zh: '你已被禁言，消息未发送',
    en: 'You are restricted from sending messages here, the message was not sent',
    pt: 'Você está impedido de enviar mensagens aqui, a mensagem não foi enviada',
  },
  sendDeniedChatRestricted: {
    zh: '该会话已被限制，消息未发送',
    en: 'This chat is restricted, the message was not sent',
    pt: 'Este chat está restrito, a mensagem não foi enviada',
  },
  sendDeniedSlowmode: {
    zh: '该群开启了慢速模式，请稍后再发',
    en: 'Slow mode is enabled in this group, please wait before sending again',
    pt: 'O modo lento está ativado neste grupo, aguarde antes de enviar novamente',
  },
} as const satisfies Record<string, CustomUiText>;
